import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.footer');
import { OnInit, Input } from '@angular/core';

@Component({
    selector: 'wiz-component-footer',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.footer/view.scss */
.footer {
  background-color: #F6F7FB;
  border: none;
}

.footer-box {
  width: 1800px;
  margin: auto;
  justify-content: space-between;
}

.info {
  margin-left: 2rem;
  gap: 0.5rem;
}`],
})
export class ComponentFooterComponent implements OnInit {

    public async ngOnInit() {
    }
}

export default ComponentFooterComponent;